/* eslint-disable require-jsdoc */
import {loadLocalization} from '~/utils/localization.js';
import {RunConfigService} from '@nuskin/ns-util';

const loadedLocales = new Set();

const rtlList = [
    'iw'
];

export default async function localizationMiddleware({app, route}) {
    const {i18n, $vuetify} = app;
    const locale = route.params?.locale;
    if (!locale) {
        return;
    }

    const lang = locale.split('_')[0];
    const isRtl = rtlList.includes(lang);
    if (typeof document !== 'undefined') {
        $vuetify.rtl = isRtl;
        document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
    }

    if (i18n.locale !== locale) {
        console.info('setting app locale to', locale);
        i18n.locale = locale;
    }
    ensureRunConfigLocaleSet(locale);

    if (!loadedLocales.has(locale)) {
        console.info('loading localization for', locale);
        await loadLocalization(i18n, locale);
        loadedLocales.add(locale);
    }
}

function ensureRunConfigLocaleSet(locale) {
    const [language, country] = locale.split('_');
    const {language: rcLang, country: rcCountry} = RunConfigService.getRunConfig();
    if (language !== rcLang || country !== rcCountry) {
        console.debug('Updating RunConfig locale from URL', {country, language});
        // If we don't clear out the siteConfigurationPath, we can end up loading the wrong region's settings.
        RunConfigService.addRunConfig({country, language, siteConfigurationPath: undefined});
    }
}
